filters = {
    const: form = [],

    init: function() {

        // If a filter exists, watch for changes and setup to log
        if (jQuery('.persistFilter').length > 0) {
            const now = new Date().getTime();
            let localStorageRecord = JSON.parse(localStorage.getItem(window.location.pathname));
            if (localStorageRecord !== null && localStorageRecord.expiry < now) {
                window.localStorage.clear();
            }

            // Save url with filters when Update button is clicked
            let url = window.location.href;

            if (url.includes("?")) {
                //indication some filters were picked, update local storage
                let item = {
                    url: url,
                    expiry: now + 7 * 24 * 60 * 60 * 1000 //week from now
                }
                localStorage.setItem(window.location.pathname, JSON.stringify(item))
            } else {
                if (localStorageRecord !== null) {
                    window.location.href = localStorageRecord.url;
                }
            }
        }
    },
};

jQuery(document).ready(function()
{
    filters.init();
});
